/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severityabandonment1Inputs */

const en_severityabandonment1 = /** @type {(inputs: Severityabandonment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonment`)
};

const pt_severityabandonment1 = /** @type {(inputs: Severityabandonment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandono`)
};

/**
* | output |
* | --- |
* | "Abandonment" |
*
* @param {Severityabandonment1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severityabandonment1 = /** @type {((inputs?: Severityabandonment1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severityabandonment1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severityabandonment1(inputs)
	return pt_severityabandonment1(inputs)
});
export { severityabandonment1 as "severityAbandonment" }